export default "__VITE_ASSET__BcUDy1gN__"